// TODO 新しい /api/gateways/task-type-api に移行する

import { client as request } from "./request";

/**
 * 業種
 */
export interface TaskType {
  taskTypeId: any;
  name: string;
}

/**
 * 業種を取得する
 */
export async function getTaskTypes() {
  const res = await request.get("get_all_task_types.php");
  return res as TaskType[];
}

/**
 * 現場に紐づいた業種を取得する
 */
export async function getTaskTypesOfProject(projectId: any) {
  const res = await request.get("get_task_types_of_project.php", {
    projectId
  });
  return res as TaskType[];
}

/**
 * 業種を保存する
 */
export async function saveTaskType(data: FormData) {
  const res = await request.post("save_task_type.php", data);
  return res.taskTypeId;
}

export async function deleteTaskType(taskTypeId: number) {
  const d = new FormData();
  d.append("taskTypeId", String(taskTypeId));
  await request.post("delete_task_type.php", d);
}
